import angular from 'angular';
import uiRouter from 'angular-ui-router';
import validationErrorComponent from './validationError.component';

let validationErrorModule = angular.module('validationError', [
  uiRouter
])

.component('validationError', validationErrorComponent)

.name;

export default validationErrorModule;
